export enum CadastroSocialStatus {
  INICIADO = 'INICIADO',
  COMPLETO = 'COMPLETO',
  CANCELADO = 'CANCELADO',
}
